import { verwaltungsstufen } from ".";
import { einheiten } from "./einheiten";
import { fachaufgaben } from "./fachaufgaben";
import { funktionen } from "./funktionen";
import { grundzeichen, } from "./grundzeichen";
import { organisationen } from "./organisationen";
import { SVG } from "./svg";
import { symbole } from "./symbole";
import { createTextSymbol } from "./text";
import { addPoints, ImageImpl, placeComponent, subtractPoints, } from "./utils";
function get(id, items) {
    if (!id)
        return undefined;
    const item = items.find((i) => i.id === id);
    if (!item)
        throw new Error(`Item not found: ${id}`);
    return item;
}
export function erzeugeTaktischesZeichen(spec) {
    var _a, _b, _c;
    const grund = get(spec.grundzeichen, grundzeichen);
    const org = get(spec.organisation, organisationen);
    const fachaufgabe = get(spec.fachaufgabe, fachaufgaben);
    const einheit = get(spec.einheit, einheiten);
    const verwaltungsstufe = get(spec.verwaltungsstufe, verwaltungsstufen);
    const funktion = get(spec.funktion, funktionen);
    const symbol = get(spec.symbol, symbole);
    if (!grund && !symbol) {
        throw new Error('Entweder "grundzeichen" oder "symbol" müssen angegeben werden.');
    }
    const svg = new SVG()
        .attr("fill", "transparent")
        .attr("stroke", "black")
        .attr("stroke-width", 2);
    const viewBox = [
        [0, 0],
        [0, 0],
    ];
    if (grund) {
        viewBox[1] = grund.size;
        svg.push(grund.render(svg, {
            fill: accepts(grund, "organisation") ? org === null || org === void 0 ? void 0 : org.background : undefined,
        }));
        if (grund.clipPath) {
            svg.def(svg.clipPath("gz-mask").push(grund.clipPath(svg)));
        }
        if (fachaufgabe && accepts(grund, "fachaufgabe")) {
            const icon = placeComponent({
                parent: grund,
                component: fachaufgabe,
                padding: fachaufgabe.cover ? undefined : grund.padding,
                svg,
            });
            svg.push(svg.g().push(icon).attr("clip-path", "url(#gz-mask)"));
        }
        let topAnchor = (_a = grund.einheitAnchor) !== null && _a !== void 0 ? _a : [
            viewBox[0][0] + (viewBox[1][0] - viewBox[0][0]) / 2,
            0,
        ];
        if (einheit && accepts(grund, "einheit")) {
            const position = [
                topAnchor[0] - einheit.size[0] / 2,
                topAnchor[1] - einheit.size[1],
            ];
            topAnchor = addPoints(topAnchor, [0, -einheit.size[1]]);
            // extend the viewbox if the icon protrudes to the top
            const ydiff = viewBox[0][1] - position[1];
            if (ydiff > 0) {
                viewBox[0] = subtractPoints(viewBox[0], [0, ydiff]);
                viewBox[1] = addPoints(viewBox[1], [0, ydiff]);
            }
            svg.push(einheit
                .render(svg)
                .attr("transform", `translate(${position[0]},${position[1]})`));
        }
        if (verwaltungsstufe && accepts(grund, "verwaltungsstufe")) {
            const position = [
                topAnchor[0] - verwaltungsstufe.size[0] / 2,
                topAnchor[1] - verwaltungsstufe.size[1],
            ];
            topAnchor = addPoints(topAnchor, [0, -verwaltungsstufe.size[1]]);
            // extend the viewbox if the icon is too large
            const ydiff = viewBox[0][1] - position[1];
            if (ydiff > 0) {
                viewBox[0] = subtractPoints(viewBox[0], [0, ydiff]);
                viewBox[1] = addPoints(viewBox[1], [0, ydiff]);
            }
            const xdiff = viewBox[0][0] - position[0];
            if (xdiff > 0) {
                viewBox[0] = subtractPoints(viewBox[0], [xdiff, 0]);
                viewBox[1] = addPoints(viewBox[1], [2 * xdiff, 0]);
            }
            svg.push(verwaltungsstufe
                .render(svg)
                .attr("transform", `translate(${position[0]},${position[1]})`));
        }
        if (funktion && accepts(grund, "funktion")) {
            const offset = (grund.size[0] - funktion.size[0]) / 2;
            svg.push(svg
                .g()
                .attr("clip-path", "url(#gz-mask)")
                .push(funktion.render(svg).attr("transform", `translate(${offset},0)`)));
        }
        if (accepts(grund, "symbol")) {
            if (symbol) {
                svg.push(svg
                    .g()
                    .attr("clip-path", "url(#gz-mask)")
                    .push(placeComponent({
                    parent: grund,
                    component: symbol,
                    padding: grund.padding,
                    svg,
                })));
            }
            if (spec.text) {
                svg.push(svg
                    .g()
                    .attr("clip-path", "url(#gz-mask)")
                    .push(placeComponent({
                    parent: grund,
                    component: createTextSymbol(spec.text, {
                        fill: (_b = org === null || org === void 0 ? void 0 : org.textColor) !== null && _b !== void 0 ? _b : "black",
                    }),
                    padding: (_c = grund.textPadding) !== null && _c !== void 0 ? _c : grund.padding,
                    svg,
                })));
            }
        }
    }
    else if (symbol) {
        viewBox[1] = symbol.size;
        svg.push(symbol.render(svg));
    }
    else {
        throw new Error('Entweder "grundzeichen" oder "symbol" müssen angegeben werden.');
    }
    svg.attr("viewBox", viewBox.flatMap((p) => p).join(" "));
    return new ImageImpl(svg, [
        viewBox[1][0] - viewBox[0][0],
        viewBox[1][1] - viewBox[0][1],
    ]);
}
function accepts({ accepts }, type) {
    if (!accepts)
        return true;
    return accepts.includes(type);
}
